import React from 'react';
import { useI18n } from '@/contexts/I18nContext';

const LanguageToggle = () => {
  const { lang, switchLang } = useI18n();

  return (
    <div className="flex items-center gap-0.5 text-xs font-medium" data-testid="language-toggle">
      <button
        onClick={() => switchLang('is')}
        className={`px-2 py-1 rounded-l-md transition-colors ${
          lang === 'is'
            ? 'bg-accent/15 text-accent'
            : 'text-foreground-muted hover:text-foreground'
        }`}
        data-testid="lang-is"
      >
        IS
      </button>
      <span className="text-border">|</span>
      <button
        onClick={() => switchLang('en')}
        className={`px-2 py-1 rounded-r-md transition-colors ${
          lang === 'en'
            ? 'bg-accent/15 text-accent'
            : 'text-foreground-muted hover:text-foreground'
        }`}
        data-testid="lang-en"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;
